export enum UserChannelCode {
    SEM_ATRIBUICAO = 0,
    DISTRIBUIDOR = 3,
    PME = 4,
    CONVENIO_SPC_SERASA = 8
}
